import React from 'react';
import { Alert, IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

export const DEFAULT_ERROR_MESSAGE = `We had some trouble with that. Please try again or contact support if the problem persists.`;
export const VALIDATION_ERROR_MESSAGE = `Please fix the validation errors below and try again`;

export default function ErrorMessage({ error, close, ...rest }) {
  return (
    <Alert
      icon={false}
      action={buildCloseErrorButton()}
      data-testid="error"
      severity="error"
      sx={{ display: 'flex', alignItems: 'center' }}
      {...rest}
    >
      {typeof error === 'string' ? error : DEFAULT_ERROR_MESSAGE}
    </Alert>
  );

  function buildCloseErrorButton() {
    if (close)
      return (
        <IconButton onClick={close} sx={{ pointerEvents: 'auto', mt: '-6px' }}>
          <CancelIcon />
        </IconButton>
      );
  }
}
